import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { WorkingConditionsVersionDetailsQuery } from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { WorkConditionVersionItemsFormData } from 'modules/contracts_settings/pages/WorkingConditionsVersionPage/forms'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

interface Props {
  data: WorkingConditionsVersionDetailsQuery | undefined
  loading: boolean
  error: unknown
  onCancel: () => void
}

const WorkingConditionVersionView = ({ loading, error, onCancel }: Props) => {
  const form = useFormContext<WorkConditionVersionItemsFormData>()

  return (
    <ResponsivePage.Body
      variant="wide"
      showHeader={false}
      loading={loading}
      error={error}
      transactionalActions={{
        primary: {
          label: i18n.t('common.save_changes'),
          onClick: form.submitForm,
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onCancel,
        },
      }}
    >
      <Box gap="s32" width="full" gapDivider>
        <Outlet />
      </Box>
    </ResponsivePage.Body>
  )
}

export default WorkingConditionVersionView
